import { render, staticRenderFns } from "./ProductionListGrants.vue?vue&type=template&id=2a96d59b&scoped=true"
import script from "./ProductionListGrants.vue?vue&type=script&lang=js"
export * from "./ProductionListGrants.vue?vue&type=script&lang=js"
import style0 from "./ProductionListGrants.vue?vue&type=style&index=0&id=2a96d59b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96d59b",
  null
  
)

export default component.exports